import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addItemGroup = catchAsync(async (body) => {
  const { data } = await axiosInstance.post('/api/resource/Item Group', body);
  return data;
});

export const updateItemGroup = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.post(
    `/api/resource/Item Group/${id}`,
    body
  );
  return data;
});

export const getItemGroup = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/resource/Item Group?fields=["name","parent_item_group","custom_item_group_id"]'
  );
  return data;
});
export const getItemGroupById = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(`/api/resource/Item Group/${id}`);
  return data;
});

export const deleteItemGroup = catchAsync(async (id) => {
  const { data } = await axiosInstance.delete(`/api/resource/Item Group/${id}`);
  return data;
});
